import React, { useEffect, useState } from 'react';

import { SENT_MAIL_TABLE_COLUMNS } from 'constants/mailing';
import useModal from 'hooks/use-modal/useModal';
import { usePaginationWithSearch } from 'hooks/use-pagination-with-search/usePaginationWithSearch';
import { getCustomMailSent } from 'modules/custom-mail/action';
import { selectSentList } from 'modules/custom-mail/selectors';
import { useAppDispatch, useAppSelector } from 'modules/store';
import { Pagination } from 'shared-components';
import Table, { TableSkeleton } from 'shared-components/table';

import MailPreviewModal from './MailPreviewModal';
import NoMails from './NoMails';
import SentMailsTableRow from './SentMailsTableRow';

const MAIL_PER_PAGE = 7;

const SentMailsList = () => {
  const dispatch = useAppDispatch();
  const { onOpen, ...modalState } = useModal();
  const { list, ...mailsPaginationData } = useAppSelector(selectSentList);
  const { page, setPage } = usePaginationWithSearch();
  const [isLoading, setIsLoading] = useState(false);
  const [currentEmail, setCurrentEmail] = useState<string>('');
  const [currentSubject, setCurrentSubject] = useState<string>('');
  const [currentBody, setCurrentBody] = useState<string>('');

  const handleOpenModal = (email: string, subject: string, body: string) => {
    setCurrentEmail(email);
    setCurrentSubject(subject);
    setCurrentBody(body);
    onOpen();
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(getCustomMailSent({ page: 1, per_page: MAIL_PER_PAGE }))
      .unwrap()
      .finally(() => setIsLoading(false));
  }, [dispatch]);

  return (
    <div>
      <Table columns={SENT_MAIL_TABLE_COLUMNS}>
        {list?.length && !isLoading ? (
          list?.map((mail) => (
            <SentMailsTableRow
              key={mail.id}
              mail={mail}
              handleOpenModal={() => handleOpenModal(mail.email, mail.subject, mail.body)}
            />
          ))
        ) : isLoading ? (
          <TableSkeleton rowsNumber={4} columnsNumber={SENT_MAIL_TABLE_COLUMNS.length} />
        ) : (
          <NoMails />
        )}
      </Table>

      <MailPreviewModal {...modalState} email={currentEmail} subject={currentSubject} body={currentBody} />

      <Pagination currentPage={page} updatePage={setPage} {...mailsPaginationData} />
    </div>
  );
};

export default SentMailsList;
